import { format, formatDistanceToNow } from 'date-fns';
// import moment from 'moment';
import { IsNullOrEmpty } from './valid';

export function fDate(date: string) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date: any) {
  return format(new Date(date), 'dd MMM yyyy h:mm a');
}

export function newfDateTime(date: any) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export function fDateTimeSuffix(date: any) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}

export function formatTimeHHmm(date: Date) {
  return format(date, 'HH:mm');
}

export function formatTimeHHmmss(date: Date) {
  return format(date, 'HH:mm:ss');
}

export function formatTimehmma(date: any) {
  return format(new Date(date), 'h:mm a');
}

export function formatDateMMDDYYYY(date: Date) {
  return format(date, 'MM/dd/yyyy');
}

export function formatDateMMMDDYYYY(dateString: string): string {
  if (IsNullOrEmpty(dateString)) return '';
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'short', // e.g. "Nov"
    day: 'numeric', // e.g. "30"
    year: 'numeric', // e.g. "2025"
  });
  return formatter.format(date); // → "Nov 30, 2025"
}

export function formatDateMMMDD(dateString: string): string {
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat('en-US', {
    month: 'short', // e.g. "Nov"
    day: 'numeric', // e.g. "30"
  });
  return formatter.format(date); // → "Nov 30, 2025"
}

export function fToNow(date: any) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export const shortWeekday = (weekday: string): string => {
  return weekday.substring(0, 3); // Shorten the weekday to first three letters
};

// export const shortMonth = (month: string): string => {
//   return moment().month(month).format('MMM'); // Shorten the month to its abbreviation
// };

export const formatDateGB = (date: string) =>
  new Date(date).toLocaleDateString('en-GB');
export const formatDate = (date: string) =>
  new Date(date).toLocaleDateString('en-US');
export const formatTime = (date: string) => new Date(date).toLocaleTimeString();
// export const getMonth = (date: Date) => parseInt(moment(date).format('M'));
// export const getYear = (date: Date) => parseInt(moment(date).format('YYYY'));
// export const getMonthNameFromNumber = (number: string) =>
//   moment(number, 'MM').format('MMM');
export const DateFormat = (date: Date) => new Date(date).toLocaleDateString();

const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export const formatDateAccordingToName = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString(undefined, options);
};

// export const parseDateToStartTimestamp = (dateString: string) => {
//   return moment(dateString).startOf('day').valueOf();
// };

// export const parseDateToEndTimestamp = (dateString: string) => {
//   return moment(dateString).endOf('day').valueOf();
// };

export function convertSecondsToTime(seconds: any) {
  if (!seconds || isNaN(seconds)) return '0:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
  const formattedMinutes = hours > 0 && minutes < 10 ? `0${minutes}` : minutes;

  return hours > 0
    ? `${hours}:${formattedMinutes}:${formattedSeconds}`
    : `${minutes}:${formattedSeconds}`;
}

export function convertSecondsToHoursMinutes(seconds: any) {
  if (!seconds || isNaN(seconds)) return '0:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${hours}:${formattedMinutes}`;
}
